import { render, staticRenderFns } from "./CoursewareHeadlineBlock.vue?vue&type=template&id=0d7d262a&scoped=true&"
import script from "./CoursewareHeadlineBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareHeadlineBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareHeadlineBlock.vue?vue&type=style&index=0&id=0d7d262a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d262a",
  null
  
)

export default component.exports